import { createSelector } from 'reselect';
import { isMaskingForced } from '../../../util/abac';
import { MaskedModeState } from './reducer';
import { evaluatedPolicySelectors } from '../evaluatedPolicy';
import { projectPickerSelectors } from '../projectPicker';
import { projectCohortPickerSelectors } from '../projectCohortPicker';

export const selectMaskedModeState = (state: any): MaskedModeState =>
  state.maskedMode;

export const selectMaskForced = createSelector(
  evaluatedPolicySelectors.selectPolicyForCurrentUser,
  projectPickerSelectors.selectActiveProjectId,
  projectCohortPickerSelectors.selectActiveProjectCohortId,
  (policy, activeProjectId, activeCohortId) => {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    return isMaskingForced(policy as any, activeProjectId, activeCohortId);
  },
);

export const selectShouldMask = createSelector(
  selectMaskedModeState,
  selectMaskForced,
  (maskedModeState, isForced) => isForced || maskedModeState.active,
);
